export const normalizeLegacyEstimateTime = (value: number | null): number | null => {
  return value !== null && Number.isFinite(value) && value > 0 ? value : null;
};

type CreateTaskForTeamValidationInput = {
  hasPriorities: boolean;
  taskName: string;
  estimate: number | null;
  startDate: string;
  endDate: string;
};

export const validateCreateTaskForTeamInput = ({
  hasPriorities,
  taskName,
  estimate,
  startDate,
  endDate,
}: CreateTaskForTeamValidationInput): string | null => {
  if (!hasPriorities) return 'No priorities found.';
  if (!taskName.trim()) return 'Task name is required.';
  if (!startDate) return 'Start date is required.';
  if (endDate && startDate > endDate) return 'Start Date cannot be after End Date.';

  return estimate !== null && (!Number.isFinite(estimate) || estimate < 0)
    ? 'Estimate Time must be greater than or equal to 0.'
    : null;
};
